/** This file is auto-generated. Do not modify directly. */
import React from 'react';
import extendIconThick from '../../extendIconThick';

const Deha21 = props => (
  <svg
    xmlnsXlink="http://www.w3.org/1999/xlink"
    viewBox="0 0 100 145"
    width="1em"
    height="1em"
    {...props}
  >
    <defs>
      <path
        d="M87.87 42.3C87.87 42.3 85.23 17.56 76.99 9.98C68.74 2.39 52.09 3.05 52.09 3.05C52.09 3.05 37.05 2.09 30.81 8.33C21.32 17.82 13.33 29.11 6.9 59.13C0.46 89.14 8.55 105.47 14.98 113.22C21.41 120.97 35.76 130.7 50.6 130.21C65.45 129.71 71.96 127.47 87.38 110.25C101.38 92.12 93.98 64.07 92.66 60.28C91.34 56.49 88.83 45.9 87.87 42.3ZM30.15 76.53C30.15 66.73 38.09 58.79 47.88 58.79C57.67 58.79 65.61 66.73 65.61 76.53C65.61 86.32 57.67 94.25 47.88 94.25C38.09 94.25 30.15 86.32 30.15 76.53ZM78.57 28.96C77.4 27.64 71.53 21.02 60.98 9.1C70.36 19.69 76.23 26.31 78.57 28.96Z"
        id="b16HgWIgT6"
      />
      <path
        d="M53.42 76.31C53.42 79.07 51.18 81.31 48.42 81.31C45.66 81.31 43.42 79.07 43.42 76.31C43.42 73.55 45.66 71.31 48.42 71.31C51.18 71.31 53.42 73.55 53.42 76.31Z"
        id="c15rAZqIpo"
      />
      <path
        d="M60.3 76.31C60.3 83.14 54.76 88.69 47.93 88.69C41.1 88.69 35.55 83.14 35.55 76.31C35.55 69.48 41.1 63.94 47.93 63.94C54.76 63.94 60.3 69.48 60.3 76.31Z"
        id="j19l62KlDF"
      />
    </defs>
    <g>
      <g>
        <g>
          <use xlinkHref="#b16HgWIgT6" opacity="1" fillOpacity="1" />
          <g>
            <use
              xlinkHref="#b16HgWIgT6"
              opacity="1"
              fill-opacity="0"
              strokeWidth="1"
              strokeOpacity="0"
            />
          </g>
        </g>
        <g>
          <use xlinkHref="#c15rAZqIpo" opacity="1" fill-opacity="1" />
        </g>
        <g>
          <use xlinkHref="#j19l62KlDF" opacity="1" fill-opacity="1" />
        </g>
      </g>
    </g>
  </svg>
);
export default extendIconThick(Deha21);
